"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateActiveTerm = void 0;

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var updateActiveTerm = function updateActiveTerm(payload) {
  return {
    type: _ActionTypes.ACTIVE_TERM_UPDATED,
    payload: payload
  };
};

exports.updateActiveTerm = updateActiveTerm;